<template>
  <transition name="fade">
    <nav id="deep-nav"
      class="deep-nav"
      v-show="isVisible && currentTabContents">

      <deep-nav-section
        v-if="currentTab"
        class="deep-nav__section"
        :contents="currentTabContents"
        :currentTab="currentTab"
        @hide-deep-nav="hide"
      />
    </nav>
  </transition>
</template>

<script>
import DeepNavSection from './DeepNavSection.vue'

const API_URL = '/actions/utils/ajax/deep-nav'

export default {
  name: 'DeepNav',

  components: {
    DeepNavSection
  },

  data () {
    return {
      tabs: null,
      isVisible: false,
      currentTab: null
    }
  },

  computed: {
    currentTabContents () {
      if ( this.currentTab && this.tabs ) {
        if (this.currentTab === 'summary') {
          return this.tabs
        } else return this.tabs[this.currentTab]
      } else return null
    }
  },

  methods: {
    show (e) {
      this.currentTab = e.target.dataset.targetUid
      if (this.currentTabContents.content || this.currentTab === 'summary') {
        this.isVisible = true
      } else this.isVisible = false
    },

    hide () {
      this.isVisible = false
    },

    getTabs () {
      fetch(API_URL, {
        credentials: 'same-origin'
      }).then(response => {
        return response.json()
      }).then(data => {
        this.tabs = data
      }).catch(error => {
        console.log(error)
      })
    },
  },

  mounted () {
    this.getTabs()
  }
}
</script>
